export const BROADCAST_CHANNEL_NAME = 'getuniq-app'

export const BROADCAST_MESSAGE_TYPES = {
  EMAIL_CONFIRMED: 'EMAIL_CONFIRMED',
  AMO_CRM_CONNECTED: 'AMO_CRM_CONNECTED',
  WEBHOOK_CREATED: 'WEBHOOK_CREATED',
}

const isSupported = () => typeof BroadcastChannel !== 'undefined'

// In-memory only: window.open copies sessionStorage from the opener, so a popup
// would otherwise share tabId and the opener would ignore its broadcast.
let tabId = null

export const getTabId = () => {
  if (!tabId) {
    tabId =
      typeof crypto?.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random()}`
  }

  return tabId
}

export const isOwnBroadcast = (data) => data?.tabId === getTabId()

export const postBroadcastMessage = (type, payload = {}) => {
  if (!isSupported()) {
    return
  }

  const channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME)

  channel.postMessage({ type, tabId: getTabId(), ...payload })
  setTimeout(() => channel.close(), 0)
}

export const subscribeToBroadcastMessages = (handler) => {
  if (!isSupported()) {
    return () => {}
  }

  const channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME)
  channel.onmessage = ({ data }) => handler(data)

  return () => {
    channel.onmessage = null
    channel.close()
  }
}

export const subscribeToBroadcastType = (type, handler) =>
  subscribeToBroadcastMessages((data) => {
    if (data?.type !== type || isOwnBroadcast(data)) {
      return
    }

    handler(data)
  })
